const doIntervalsOverlap = (intervals) => {
  const sortedIntervals = [...intervals].sort((a, b) => a[0] - b[0]);
  return sortedIntervals.some((current, index, array) =>
    index === 0 ? false : current[0] < array[index - 1][1]
  );
};

export default doIntervalsOverlap;
